'use strict';

const trackingConsentData = $('.tracking-consent');
const urlAccept = trackingConsentData.data('accept');
const urlReject = trackingConsentData.data('reject');
const tokenName = trackingConsentData.data('tokenname');
const token = trackingConsentData.data('token');

function setConsentSFRA(state) {
    var url = null;
    
    if (state === 'accept') {
        url = urlAccept
    } else if (state === 'reject') {
        url = urlReject;
    } else {
        return;
    }
    
    var data = {};
    data[tokenName] = token;
    $.ajax({
        url: url,
        type: 'post',
        data: data,
        dataType: 'json',
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            }
        }
    });
}

async function handleSFCCConsent() {
    const UC = window.UC_UI;
    if (!UC?.getServicesBaseInfo) return;

    const services = await UC.getServicesBaseInfo();
    const sfcc = services.find(
        s => s.name === "Salesforce Analytics"
    );

    if (sfcc?.consent?.status) {
        setConsentSFRA('accept');
    } else {
        setConsentSFRA('reject');
    }
}

window.addEventListener("UC_UI_CMP_EVENT", (ev) => {
    if (ev?.detail?.type === "SAVE") {
        handleSFCCConsent();
    }
});

export function init() {
    document.addEventListener('ucControlled:loaded', ev => {
        setConsentSFRA('accept');
    });

    document.addEventListener('ucControlled:denied', ev => {
        setConsentSFRA('reject');
    });
}
